import { Control, Controller } from "react-hook-form";

import StyledTextFieldWithTitle from "@/modules/common/components/input/styled-text-field-with-title";
import { format } from "date-fns";
import { Typography } from "@mui/material";

function EditRentalInfoForm({ control }: Readonly<{ control: Control<any> }>) {
  return (
    <>
      <Controller
        control={control}
        name="showingFrom"
        render={({ field, fieldState }) => (
          <StyledTextFieldWithTitle
            {...field}
            value={
              field.value
                ? format(new Date(field.value), "yyyy-MM-dd")
                : undefined
            }
            type="date"
            title="Showing Start Date"
            placeholder="Showing Start Date"
            fullWidth
            size="small"
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
          />
        )}
      ></Controller>
      <Controller
        control={control}
        name="availableFrom"
        render={({ field, fieldState }) => (
          <StyledTextFieldWithTitle
            {...field}
            value={
              field.value
                ? format(new Date(field.value), "yyyy-MM-dd")
                : undefined
            }
            type="date"
            title="Rental Start Date"
            placeholder="Rental Start Date"
            fullWidth
            size="small"
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
          />
        )}
      ></Controller>

      <Controller
        control={control}
        name="rentalPrice"
        render={({ field, fieldState }) => (
          <StyledTextFieldWithTitle
            {...field}
            formatNumeric
            title="Rental Price"
            placeholder="Rental Price"
            fullWidth
            size="small"
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            slotProps={{
              input: {
                endAdornment: <Typography>EGP</Typography>,
              },
            }}
          />
        )}
      ></Controller>
    </>
  );
}

export default EditRentalInfoForm;
